import { Router } from '@vaadin/router';

export const initRouter = () => {
  window.addEventListener('vaadin-router-location-changed', (e: any) => {
    window.scrollTo(0, 0);
  });

  window.addEventListener('load', () => {
    const router = new Router(document.querySelector('main'));

    router.setRoutes([
      // --- PARAMASTER ----------------------------
      {
        path: '/welcome',
        component: 'paramaster-welcome-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-welcome-page" */ /* webpackMode: "lazy" */ './pages/ParamasteWelcomePage'
            )
          ),
      },

      {
        path: '/paramaster',
        component: 'paramaster-calculator-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-calculator-page" */ /* webpackMode: "lazy" */ './pages/ParamasteCalculatorPage'
            )
          ),
      },
      {
        path: '/einstellungen',
        component: 'paramaster-einstellungen-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-einstellungen-page" */ /* webpackMode: "lazy" */ './pages/ParamasteEinstellungenPage'
            )
          ),
      },
      {
        path: '/users',
        component: 'paramaster-userlist-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-userlist-page" */ /* webpackMode: "lazy" */ './pages/ParamasterUserlistPage'
            )
          ),
      },
      {
        path: '/users/:id',
        component: 'paramaster-usereditor-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-usereditor-page" */ /* webpackMode: "lazy" */ './pages/ParamasterUsereditorPage'
            )
          ),
      },
      {
        path: '/registrieren',
        component: 'paramaster-registrieren-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-registrieren-page" */ /* webpackMode: "lazy" */ './pages/ParamasteRegistrierenPage'
            )
          ),
      },
      {
        path: '/registrieren-app',
        component: 'paramaster-registrieren-app-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-registrieren-app-page" */ /* webpackMode: "lazy" */ './pages/ParamasteRegistrierenAppPage'
            )
          ),
      },

      {
        path: '/datenschutz',
        component: 'paramaster-datenschutz-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-datenschutz-page" */ /* webpackMode: "lazy" */ './pages/ParamasteDatenschutzPage'
            )
          ),
      },
      {
        path: '/nutzungsbedingungen',
        component: 'paramaster-nutzungsbedingungen-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-nutzungsbedingungen-page" */ /* webpackMode: "lazy" */ './pages/ParamasteNutzungsbedingungenPage'
            )
          ),
      },
      // {
      //     path: "/translations",
      //     component: "paramaster-translations-page",
      //     action: () => <any>import(/* webpackChunkName: "paramaster-translations-page" */ /* webpackMode: "lazy" */ "./pages/ParamasterTranslationsPage"),
      // },
      {
        path: '/datamanager',
        component: 'paramaster-datamanager-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "paramaster-datamanager-page" */ /* webpackMode: "lazy" */ './pages/ParamasterDatenmanagerPage'
            )
          ),
      },

      // --- MISC ----------------------------------
      {
        path: '/',
        redirect: '/paramaster',
      },
      {
        path: '/signin',
        redirect: '/welcome',
      },
      {
        path: '(.*)',
        component: 'not-found-page',
        action: () =>
          <any>(
            import(
              /* webpackChunkName: "not-found-page" */ /* webpackMode: "lazy" */ './pages/NotFoundPage'
            )
          ),
      },
    ]);
  });
};
